module.exports = __webpack_public_path__ + "static/media/promo_help_pic_freelancer@2x.ea665401eb8c3b47129566854fd1afe9.png";